import React from "react";


const Footer = () => (
  <div className="footer no-print">
    <p className="footer__text">
      &copy; { new Date().getFullYear()} e-Auditoria. Todos os direitos reservados.
    </p>

    <div className="footer__social">
      <a
        className="footer__social___link"
        href="https://facebook.com/eauditoriasaas"
        rel="noopener noreferrer"
        target="_blank"
      >
        <i className="fab fa-facebook-f fa-lg" />
      </a>
      <a
        className="footer__social___link"
        href="https://twitter.com/e_auditoria"
        rel="noopener noreferrer"
        target="_blank"
      >
        <i className="fab fa-twitter fa-lg" />
      </a>
      <a
        className="footer__social___link"
        href="https://linkedin.com/company/eauditoria"
        rel="noopener noreferrer"
        target="_blank"
      >
        <i className="fab fa-linkedin-in fa-lg" />
      </a>
      <a
        className="footer__social___link"
        href="https://youtube.com/user/eauditoria"
        rel="noopener noreferrer"
        target="_blank"
      >
        <i className="fab fa-youtube fa-lg" />
      </a>
      <a
        className="footer__social___link"
        href="http://www.e-auditoria.com.br"
        rel="noopener noreferrer"
        target="_blank"
      >
        <img
          src="https://images.e-auditoria.com.br/global/logos/png/e-auditoria-white.png"
          alt="e-Auditoria"
        />
      </a>
    </div>
  </div>
);

export default Footer;
